import { getProductLogoUrl } from "../../utils/product-logos";

export function ProductLogo({
  slug,
  name,
  size = 56,
  className = "",
}: {
  slug: string;
  name: string;
  size?: number;
  className?: string;
}) {
  const src = getProductLogoUrl(slug);

  if (!src) {
    const initials = name
      .replace(/^ITaaS\s+/i, "")
      .split(/\s+/)
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase() ?? "")
      .join("");
    return (
      <div
        className={`pep-product-logo-fallback ${className}`.trim()}
        style={{ width: size, height: size, fontSize: Math.round(size * 0.32) }}
        aria-hidden
      >
        {initials || "IT"}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt=""
      className={`pep-product-logo ${className}`.trim()}
      height={size}
      width="auto"
      loading="lazy"
      decoding="async"
    />
  );
}
